import { Injectable } from '@angular/core';

import { locaisStorage, TiposLocais } from "./data.service";
import { AutoCompleteService } from "../../../shared/components/autocomplete/autocomplete.service";
import { bombasStorage } from "../../bombas/shared/data.service";
import { BombaService } from "../../bombas/shared/bomba.service";
import { BombaNavigationService } from "../../bombas/shared/bomba-navigation.service";
import { tanquesStorage } from "../../tanques/shared/data.service";
import { TanqueService } from "../../tanques/shared/tanque.service";
import { TanqueNavigationService } from "../../tanques/shared/tanque-navigation.service";
import { UtilService } from "../../../shared/services/util.service";

@Injectable()
export class LocalService {

    constructor(
        private _bombaService: BombaService,
        private _bombaNavigationService: BombaNavigationService,
        private _autocompleteService: AutoCompleteService,
        private _tanqueService: TanqueService,
        private _tanqueNavigationService: TanqueNavigationService,
        private _utilService: UtilService
    ) { }

    //session
    setSessionStorage(item: any) {
        var object: string = JSON.stringify(item);
        sessionStorage.setItem(locaisStorage + '-new', object);
    }

    getSessionStorage() {
        var item: string = sessionStorage.getItem(locaisStorage + "-new");
        return JSON.parse(item);
    }

    clearSessionStorage() {
        sessionStorage.removeItem(locaisStorage + "-new");
    }

    setSessionStorageFatherModule(item: any) {
        var object: string = JSON.stringify(item);
        sessionStorage.setItem(locaisStorage + '-father', object);
    }

    getSessionStorageFatherModule() {
        var item: string = sessionStorage.getItem(locaisStorage + "-father");
        return JSON.parse(item);
    }

    clearSessionStorageFatherModule() {
        sessionStorage.removeItem(locaisStorage + "-father");
    }

    returnToOtherForm(otherForm: string, Response: any) {
        var otherFormObject: any;
        if(Response) {
            if (otherForm === bombasStorage) {
                otherFormObject = this._bombaService.getSessionStorage();
                otherFormObject.local = Response;
                this._bombaService.setSessionStorage(otherFormObject);
            } else if (otherForm === tanquesStorage) {
                otherFormObject = this._tanqueService.getSessionStorage();
                otherFormObject.local = Response;
                this._tanqueService.setSessionStorage(otherFormObject);
            }
        }

        this._autocompleteService.clearSessionStorage(locaisStorage);

        if (otherForm === bombasStorage) {
            otherFormObject = this._bombaService.getSessionStorage();
            if (otherFormObject.id) {
                this._bombaNavigationService.goToEdit(otherFormObject.id);
            } else {
                this._bombaNavigationService.goToNew();
            }
        } else if (otherForm === tanquesStorage) {
            otherFormObject = this._tanqueService.getSessionStorage();
            if (otherFormObject.id) {
                this._tanqueNavigationService.goToEdit(otherFormObject.id);
            } else {
                this._tanqueNavigationService.goToNew();
            }
        }
    }

    getTipoLocal(tipo: number) {
        var tipos: any[] = TiposLocais,
            x: any, lenX: any;

        for (x = 0, lenX = tipos.length; x < lenX; x++) {
            if (tipos[x].Key === tipo) {
                tipo = tipos[x];
                break;
            }
        }

        return tipo;
    }

    getTipoInterno() {
        var tipos: any[] = this._utilService.cloneObject(TiposLocais),
            x: any, lenX: any, tipo: any;

        for (x = 0, lenX = tipos.length; x < lenX; x++) {
            if (tipos[x].Key === 1) {
                tipo = tipos[x];
                break;
            }
        }

        return tipo;
    }

    getTipoConvenio() {
        var tipos: any[] = this._utilService.cloneObject(TiposLocais),
            x: any, lenX: any, tipo: any;

        for (x = 0, lenX = tipos.length; x < lenX; x++) {
            if (tipos[x].Key === 2) {
                tipo = tipos[x];
                break;
            }
        }

        return tipo;
    }

    templateResult = (function(state: any, isCreateNew: boolean) {
        let stateReturn: any,
            text: string = '';

        if (state.loading) {
            stateReturn = state.text;
        } else {
            if (state.id === -1) {
                if (isCreateNew) {
                    stateReturn = this._autocompleteService.setNewTagInList(state);
                } else {
                    stateReturn = this._autocompleteService.setNoCreateNew(state.text);
                }
            } else {
                if (state.text) {
                    text = state.text;
                } else {
                    if (state.nome) {
                        text = state.nome;
                    }
                }
                stateReturn = $('<span>' + text + '</span>');
            }
        }

        return stateReturn;
    }.bind(this));

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/locais/shared/local.service.ts
 **/